export default "__VITE_ASSET__B9OBD$Z0__"